import {GiftStatus, GiftsIconType} from '@/stores/GiftsStore/GiftsStore.constants';
import {UserGift, UserTicket} from '@/stores/GiftsStore/GiftsStore.types';

import {ArrayOperations} from '@/utils/ArrayOperations';

import {ProjectDate} from '../../ProjectDate/ProjectDate';

export const createGiftsList = (projectDate: ProjectDate): UserGift[] => {
  const dateForActiveGift = projectDate.date;
  dateForActiveGift.setDate(dateForActiveGift.getDate() + 1);

  const dateForNotActiveGift = projectDate.date;
  dateForNotActiveGift.setDate(dateForNotActiveGift.getDate() - 1);

  return [
    {
      id: 'gift1',
      status: GiftStatus.Received,
      isNew: false,
      activeBefore: dateForActiveGift.toISOString(),
      title: 'Скидка 50% на подписку Т-Банк Pro',
      description:
        '%ul%' +
        '%li%Действует в течение двух недель%li%' +
        '%li%Кэшбэк суммируется с основным%li%' +
        '%li%Оплатите покупку своей картой Тинькофф %li%' +
        '%li%Максимальный кэшбэк — 3000 рублей, бонусов или миль%li%' +
        '%li%Еще больше подробстей по ссылке%li%' +
        '%ul%',
      cta: {
        text: 'Подключить',
        link: 'https://test.ru',
        iosLink: 'https://test.ru',
        deeplink: 'tinvesting://www.tbank.ru/invest/projects?projectId=invest24',
        investAppDeeplink: 'tinvesting://www.tbank.ru/invest/projects?projectId=invest24',
      },
      iconType: GiftsIconType.TPro,
    },
    {
      id: 'gift2',
      status: GiftStatus.Pending,
      isNew: false,
      activeBefore: dateForActiveGift.toISOString(),
      title: '600 рублей на Т-Шоп',
      description:
        '%ul%' +
        '%li%Действует в течение двух недель%li%' +
        '%li%Кэшбэк суммируется с основным%li%' +
        '%li%Оплатите покупку своей картой Тинькофф%li%' +
        '%li%Максимальный кэшбэк — 3000 рублей, бонусов или миль%li%' +
        '%li%Еще больше подробстей по %link%href=https://test.ru;text=ссылке%link%%li%' +
        '%ul%',
      cta: {
        text: 'Подключить',
        link: 'https://test.ru',
        iosLink: 'https://test.ru',
        deeplink: null,
        investAppDeeplink: null,
      },
      iconType: GiftsIconType.TInvest,
    },
    {
      id: 'gift3',
      status: GiftStatus.Pending,
      isNew: true,
      activeBefore: dateForActiveGift.toISOString(),
      title: 'Новый подарок',
      description: 'Описание нового подарка',
      cta: {
        text: null,
        link: null,
        iosLink: null,
        deeplink: null,
        investAppDeeplink: null,
      },
      iconType: GiftsIconType.TastyCoffee,
    },
    {
      id: 'gift4',
      status: GiftStatus.Received,
      isNew: false,
      activeBefore: dateForNotActiveGift.toISOString(),
      title: 'Не активный подарок',
      description: 'Тут описание подарка',
      cta: {
        text: 'Подключить',
        link: 'https://test.ru',
        iosLink: 'https://test.ru',
        deeplink: null,
        investAppDeeplink: null,
      },
      iconType: null,
    },
    {
      id: 'gift5',
      status: GiftStatus.Received,
      isNew: false,
      activeBefore: dateForActiveGift.toISOString(),
      title: 'Подарок с cta.link',
      description: 'Описание',
      cta: {
        text: null,
        link: 'https://test.ru',
        iosLink: null,
        deeplink: null,
        investAppDeeplink: null,
      },
      iconType: null,
    },
    {
      id: 'gift6',
      status: GiftStatus.Pending,
      isNew: false,
      activeBefore: dateForNotActiveGift.toISOString(),
      title: 'Не активный подарок со статусом Pending',
      description: '',
      cta: null,
      iconType: null,
    },
    {
      id: 'gift7',
      status: GiftStatus.Received,
      isNew: true,
      activeBefore: dateForActiveGift.toISOString(),
      title: 'Подарок без cta',
      description: 'Описание',
      cta: null,
      iconType: null,
    },
  ];
};

export const createTicketsList = (count: number): UserTicket[] => {
  return [
    ...ArrayOperations.range(0, count - 1).map((index) => ({
      id: `ticket_${index}`,
      number: `${index}${index}${index}-${index}${index}${index}-${index}${index}`,
      isNew: index % 2 === 0,
    })),
  ];
};
